import { useState } from 'react';
import { useCart } from '@/context/CartContext';
import { useTranslation } from 'react-i18next';

export const EDKHero = () => {
  const { addToCart } = useCart();
  const [added, setAdded] = useState(false);
  const { t } = useTranslation();

  const handleAddToCart = () => {
    addToCart({
      id: 'edk-complete-kit',
      name: 'Evil Energy Destroy Kit Compleet',
      price: 79.95,
      type: 'kit',
      description: 'Compleet ritueel pakket incl. Blueprint, Kruidenmix, Abalone Schelp, Uilenveer, Brandkool & Witte Kaars.',
      image: 'https://public.readdy.ai/ai/img_res/3bbe4ef6f800b1c88b3e05245c1e4f77.jpg',
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20dark%20ancient%20ritual%20burning%20fire%20purification%20ceremony%20destruction%20of%20evil%20dark%20energy%20black%20obsidian%20background%20intense%20orange%20red%20flames%20smoke%20rising%20ancient%20shamanic%20ritual%20extreme%20power%20destruction%20of%20negative%20forces%20dark%20atmospheric%20cinematic%20wide%20dramatic%20shadows%20deep%20black&width=1920&height=1080&seq=edkhero1&orientation=landscape"
          alt="Evil Energy Destroy Kit"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#080000]/90 via-[#080000]/75 to-[#080000]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#080000]/70 via-transparent to-[#080000]/70" />
      </div>

      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(16)].map((_, i) => (
          <div key={i} className="absolute rounded-full"
            style={{
              width: i % 3 === 0 ? '3px' : '2px', height: i % 3 === 0 ? '3px' : '2px',
              background: i % 2 === 0 ? 'rgba(251,146,60,0.6)' : 'rgba(239,68,68,0.5)',
              left: `${5 + i * 6}%`, top: `${15 + (i % 5) * 16}%`,
              animation: `pulse ${1.5 + (i % 4) * 0.7}s ease-in-out infinite`,
              animationDelay: `${i * 0.3}s`,
            }} />
        ))}
      </div>

      <div className="relative z-10 w-full text-center px-6 lg:px-12 flex flex-col items-center">
        <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-orange-900/40 border border-orange-500/40 rounded-full mb-8">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-fire-line text-orange-400 text-sm" />
          </div>
          <span className="text-orange-300 text-xs font-bold uppercase tracking-widest">{t('edk_hero_badge')}</span>
        </div>

        <h1 className="text-5xl lg:text-7xl font-black text-white mb-6 leading-tight">
          Evil Energy<br />
          <span className="text-transparent bg-gradient-to-r from-orange-400 via-red-400 to-orange-500 bg-clip-text">
            Destroy Kit
          </span><br />
          <span className="text-3xl lg:text-4xl text-white/70 font-bold">{t('edk_hero_title').split('!')[1] ? t('edk_hero_title') : 'Compleet!'}</span>
        </h1>

        <p className="text-white/60 text-base lg:text-lg max-w-2xl mx-auto leading-relaxed mb-4">{t('edk_hero_sub')}</p>
        <p className="text-orange-300/70 text-sm max-w-xl mx-auto leading-relaxed mb-10">{t('edk_hero_pure')}</p>

        <div className="flex items-center justify-center gap-4 mb-10">
          <span className="text-white/30 text-xl line-through font-medium">&euro;99,95</span>
          <div className="flex flex-col items-center">
            <span className="text-4xl font-black text-orange-400">&euro;79,95</span>
            <span className="text-orange-300/60 text-xs uppercase tracking-wider">{t('edk_hero_complete')}</span>
          </div>
          <div className="px-3 py-1 bg-orange-500/20 border border-orange-500/40 rounded-full">
            <span className="text-orange-300 text-xs font-bold">-20%</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-4 mb-16">
          <button onClick={handleAddToCart}
            className={`inline-flex items-center gap-2 px-10 py-4 font-black text-base rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
              added ? 'bg-emerald-600 text-white' : 'bg-gradient-to-r from-orange-600 to-red-700 text-white hover:opacity-90'
            }`}>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={`${added ? 'ri-check-line' : 'ri-shopping-bag-line'} text-base`} />
            </div>
            {added ? t('edk_hero_added') : `${t('edk_hero_add')} — \u20AC79,95`}
          </button>
          <a href="#problemen"
            className="inline-flex items-center gap-2 px-10 py-4 bg-white/5 border border-white/15 text-white/80 font-semibold text-base rounded-full hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-line text-base" />
            </div>
            {t('edk_hero_discover')}
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-8 lg:gap-16">
          {[
            { value: '11', label: t('edk_hero_stat1') },
            { value: '3', label: t('edk_hero_stat2') },
            { value: '100%', label: t('edk_hero_stat3') },
            { value: '4.9★', label: t('edk_hero_stat4') },
          ].map(stat => (
            <div key={stat.label} className="text-center">
              <p className="text-orange-400 font-black text-2xl lg:text-3xl">{stat.value}</p>
              <p className="text-white/35 text-xs mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/30 text-lg" />
        </div>
      </div>
    </section>
  );
};
